import { render } from "./DownloadMpfStatementYear.vue?vue&type=template&id=c1139974"
import script from "./DownloadMpfStatementYear.vue?vue&type=script&lang=js"
export * from "./DownloadMpfStatementYear.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__